export default function TandMList({
  activeTab,
  setActiveTab,
  filteredTimeAndMaterials,
  handleCreateToggle,
  handleEdit,
  handleView,
  handleStatusChange,
  handleConvertToChangeOrder,
  costCodeOptions,
  availableLabourItems,
  vendorOptions,
}) {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-white tracking-tight">
          Time and Material Entries
        </h2>
        <button
          onClick={handleCreateToggle}
          className="px-4 py-2 text-sm font-medium text-gray-200 bg-orange-400 rounded-md hover:bg-orange-500 transition-colors duration-200 shadow-sm"
        >
          New Entry
        </button>
      </div>
      <div className="border-b border-gray-600 mb-4">
        <nav className="flex space-x-4">
          {["Pending", "Approved", "Rejected"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`py-2 px-4 text-sm font-medium rounded-t-md transition-colors duration-200 ${
                activeTab === tab
                  ? "bg-gray-600 text-orange-400 border-b-2 border-orange-400"
                  : "text-gray-400 hover:text-gray-200 hover:bg-gray-600"
              }`}
            >
              {tab}
            </button>
          ))}
        </nav>
      </div>
      <div className="bg-gray-700 rounded-lg shadow-md border border-gray-600 overflow-hidden">
        <table className="min-w-full divide-y divide-gray-600">
          <thead className="bg-gray-800">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Created By
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Scope of Work
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Approved By
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Total Cost
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Total Price
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Overhead %
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-4 text-right text-xs font-medium text-gray-400 uppercase tracking-wider actions-column">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-600">
            {filteredTimeAndMaterials.length > 0 ? (
              filteredTimeAndMaterials.map((entry) => {
                const totalCost =
                  entry.labourItems.reduce(
                    (sum, item) =>
                      sum + (item.budget ? item.totalCost || 0 : 0),
                    0,
                  ) +
                  entry.materialItems.reduce(
                    (sum, item) =>
                      sum + (item.budget ? item.totalCost || 0 : 0),
                    0,
                  );
                const totalPrice =
                  entry.labourItems.reduce(
                    (sum, item) =>
                      sum + (item.customer ? item.totalPrice || 0 : 0),
                    0,
                  ) +
                  entry.materialItems.reduce(
                    (sum, item) =>
                      sum + (item.customer ? item.totalPrice || 0 : 0),
                    0,
                  );

                return (
                  <tr
                    key={entry._id}
                    onClick={(e) => {
                      if (e.target.closest(".actions-column")) return;
                      handleView(entry);
                    }}
                    className="hover:bg-gray-500 cursor-pointer transition-colors duration-200"
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200">
                      {entry.createdBy?.displayName || "Unknown"}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-200 max-w-xs truncate">
                      {entry.scopeOfWork || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200">
                      {entry.signedBy || "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200">
                      ${totalCost.toFixed(2)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200">
                      ${totalPrice.toFixed(2)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200">
                      {entry.overheadPercentage.toFixed(2)}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200">
                      <span
                        className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          entry.status === "Pending"
                            ? "bg-yellow-400/20 text-yellow-400"
                            : entry.status === "Approved"
                              ? "bg-green-400/20 text-green-400"
                              : "bg-red-400/20 text-red-400"
                        }`}
                      >
                        {entry.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right space-x-2 actions-column">
                      {entry.status === "Pending" ? (
                        <>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(entry);
                            }}
                            className="text-orange-400 hover:text-orange-300 transition-colors duration-200 font-medium"
                          >
                            Edit
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleStatusChange(entry._id, "Approved");
                            }}
                            className="text-green-400 hover:text-green-300 transition-colors duration-200 font-medium"
                          >
                            Approve
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleStatusChange(entry._id, "Rejected");
                            }}
                            className="text-red-400 hover:text-red-300 transition-colors duration-200 font-medium"
                          >
                            Reject
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleView(entry);
                            }}
                            className="text-orange-400 hover:text-orange-300 transition-colors duration-200 font-medium"
                          >
                            View
                          </button>
                          {entry.status === "Approved" && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleStatusChange(entry._id, "Rejected");
                              }}
                              className="text-red-400 hover:text-red-300 transition-colors duration-200 font-medium"
                            >
                              Reject
                            </button>
                          )}
                          {entry.status === "Rejected" && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleStatusChange(entry._id, "Approved");
                              }}
                              className="text-green-400 hover:text-green-300 transition-colors duration-200 font-medium"
                            >
                              Approve
                            </button>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="8"
                  className="px-6 py-4 text-center text-sm text-gray-400"
                >
                  No entries available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
